import { createSlice } from "@reduxjs/toolkit";

import { LOCAL_STORAGE_ROLES } from "../../../Utils/constant";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  roleForEdit: {
    id: undefined,
    name: "",
  },
  message: null,
  messageType: null,
  showMessage: false,
  stateData: {},
  selectedTab: 0,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const rolesSlice = createSlice({
  name: LOCAL_STORAGE_ROLES,
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // role loader
    listLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    roleList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadroleForEdit: (state, action) => {
      const payload = action.payload;

      state.roleForEdit.role = payload.role;
      state.roleForEdit.id = payload.id;
      state.roleForEdit.description = payload.description;
    },
    loadroleMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
    loadState: (state, action) => {
      state.stateData = action.payload;
    },
    setTab: (state, action) => {
      state.selectedTab = action.payload;
    },
  },
});
